import { createFileRoute, redirect } from "@tanstack/react-router";

// The agents' address opens on Team: who reports to whom, beside the lead agent's conversation.
export const Route = createFileRoute("/_console/p/$org/$project/loop/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/p/$org/$project/loop/team",
      params: { org: params.org, project: params.project },
      replace: true,
    });
  },
});
